// extracted by mini-css-extract-plugin
module.exports = {"action":"ItemTemplatesTable_action__1_C7o","editableRow":"ItemTemplatesTable_editableRow__QJchH"};